// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_5o-6";
export var headerCell = "_5o-2";
export var rowWrapper = "_5o-4";
export var stickyAggregationCell = "_5o-a";
export var stickyAggregationRow = "_5o-7";
export var stickyColumnCell = "_5o-9";
export var stickyColumnHeaderCell = "_5o-8";
export var table = "_5o-1";
export var virtualRowWrapper = "_5o-5";
export var virtualTableContainer = "_5o-0";
export var white = "_5o-3";